import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mtn-analytics-sales-data-error',
  templateUrl: './analytics-sales-data-error.component.html',
  styleUrl: './analytics-sales-data-error.component.scss'
})
export class AnalyticsSalesDataErrorComponent {
 @Output() goBack = new EventEmitter<void>();

  onGoBack(): void {
    this.goBack.emit();
  }
}
